
import React from 'react';
import withRakstsJaunumiQuery from 'utils/withRakstsJaunumiQuery';

const PostDefault = (props) => {
  const PageWithRakstsJaunumi = withRakstsJaunumiQuery({
    lang: props.lang,
    teksti: [
      'publicets',
      'atjaunots',
      'no',
      'ieprieksejais_slaids',
      'nakamais_slaids',
      'sis_ir_pirmais_slaids',
      'sis_ir_pedejais_slaids',
      'iet_uz_slaidu',
      'apskatit_attelu_originalizmera'
    ]
  });
  return <PageWithRakstsJaunumi {...props} />
}

export default PostDefault;



// WEBPACK FOOTER //
// ./src/components/PostDefault.js